export const SET_PANNEAUX_CLIENT = 'SET_PANNEAUX_CLIENT';
export const SET_CLIENT = 'SET_CLIENT';
export const SET_FILTER_IN_PDV = 'SET_FILTER_IN_PDV';
export const SET_FILTER_IN_ENSEIGNE = 'SET_FILTER_IN_ENSEIGNE';
export const SET_DATA_TIERS_FILTER = 'SET_DATA_TIERS_FILTER';
export const SET_VALUE_PROPRIETY_FILTER = 'SET_VALUE_PROPRIETY_FILTER';
export const SET_CURR_FILTER = 'SET_CURR_FILTER';
export const SET_TIERS_ALL = 'SET_TIERS_ALL';
export const SET_TIERS_ALL_INIT = 'SET_TIERS_ALL_INIT';
export const SET_TIERS_ALL_FOR_HASH = 'SET_TIERS_ALL_FOR_HASH';
export const SET_PRODUITS_CARTO = 'SET_PRODUITS_CARTO';
export const SET_MONTANT_TOTAL = 'SET_MONTANT_TOTAL';
export const SET_DEPARTEMENTS = 'SET_DEPARTEMENTS';
export const SET_CONCURRENTS = 'SET_CONCURRENTS';
export const SET_FILTER_RAYON = 'SET_FILTER_RAYON';
export const SET_NBRE_CONCURRENTS = 'SET_NBRE_CONCURRENTS';
export const SET_SOCIETE = 'SET_SOCIETE';
